import React from "react"
import { PortfolioCardContainer, PortfolioImage } from "./PortfolioCardStyle"

const PortfolioCard = (props) => (
    <PortfolioCardContainer>
        <PortfolioImage src={`../images/portfolio/${props.portfolio.image}.jpg`} alt={`${props.portfolio.title} – ${props.portfolio.description}`}/>
    </PortfolioCardContainer>
)

export default PortfolioCard